import hljs from 'highlight.js';
import {LangType} from "~~/package/mapper/learning/model/LangType";

const isEmptyString = (str: string | undefined | null): boolean => {
  if (!str) return true;
  return str.trim().length === 0;

};

const convertCodeHighlighting = (code: string, lang = LangType.PYTHON) => {
  return hljs.highlight(code, {language: convertLangType(lang)}).value;
}

const convertLangType = (lang: LangType) => {
  switch (lang as LangType) {
    case LangType.C:
      return "c"
    case LangType.CPP:
      return "cpp"
    case LangType.CSHARP:
      return "csharp"
    case LangType.JAVA:
      return "java"
    case LangType.SQL_POSTGRESQL:
    case LangType.SQL_MYSQL:
    case LangType.SQL_MYSQL_V8:
    case LangType.SQL_ORACLE:
      return "sql"
    case LangType.JAVASCRIPT:
      return "javascript"
    case LangType.GOLANG:
      return "go"
    default:
      return "python"
  }
}

const convertHtmlWithCodeHighlighting = (html: string, disableClipboard = false) => {
  const codeBlockRegex = /<code class="(language[^"]*)">([\s\S]*?)<\/code>/g;

  let convertHTML = html;
  if(!disableClipboard) {
    convertHTML = html
        .replace(/<code>/g, '<code class="copy">')
  }

  return convertHTML
      .replace(codeBlockRegex, (text) => {
    const modifiedBlock = replaceBlock(text, disableClipboard);
    return modifiedBlock || '';
  });
}

const replaceBlock = (block: string, disableClipboard: boolean) => {
  const languageMatch = block.match(/class="language-(.*?)"/);
  const language = languageMatch ? languageMatch[1] : '';

  const oldTextMatch = block.match(/<code[^>]*>(.*?)<\/code>/s);
  const oldText = oldTextMatch ? oldTextMatch[1] : '';

  let newText = '';
  if (['c', 'cs', 'cpp', 'css', 'html', 'java', 'javascript', 'php', 'python', 'ruby', 'typescript', 'xml', 'sql', 'postgresql', 'bash', 'armasm'].includes(language)) {
    const recoveredEntityText = oldText
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(/&nbsp;/g, ' ')
        .replace(/&times;/g, '×')
        .replace(/&divide;/g, '÷')
        .replace(/&le;/g, '≤')
        .replace(/&ge;/g, '≥')
        .replace(/&dollar;/g, '$')
        .replace(/&infin;/g, '∞')
        .replace(/&pi;/g, 'π')
        .replace(/&sqrt;/g, '√')
        .replace(/&hellip;/g, '…')
        .replace(/&bull;/g, '•');

    newText = hljs.highlight(recoveredEntityText, {language}).value;
  } else {
    newText = oldText;
  }

  const classes = [`language-${language}`];
  if (!disableClipboard) classes.push('copy');

  return `<code class="${classes.join(' ')}">${newText}</code>`;
}

const encodeHtmlEntities = (text: string) => {
  return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;')
      .replace(/ /g, '&nbsp;')
      .replace(/×/g, '&times;')
      .replace(/÷/g, '&divide;')
      .replace(/≤/g, '&le;')
      .replace(/≥/g, '&ge;')
      .replace(/\$/g, '&dollar;')
      .replace(/∞/g, '&infin;')
      .replace(/π/g, '&pi;')
      .replace(/√/g, '&sqrt;')
      .replace(/…/g, '&hellip;')
      .replace(/•/g, '&bull;');
}

const convertToCommaNumber = (number: number): string => {
  try {
    return number.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (e) {
    return "";
  }
}

const convertToNextLine = (text: string): string => {
  return text.replace(/\n/g, " <br/>")
}

// 텍스트 포맷팅: `텍스트`는 <code>, **텍스트**는 <strong>
const formatTextWithCode = (text: string): string => {
  if (!text) return '';
  // 먼저 `텍스트`를 <code>텍스트</code>로 변환
  let formatted = text.replace(/`(.*?)`/g, '<code>$1</code>');
  // **텍스트**를 <strong>텍스트</strong>로 변환
  formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  return formatted;
};

export { isEmptyString, convertCodeHighlighting, convertToCommaNumber, convertToNextLine, convertHtmlWithCodeHighlighting, encodeHtmlEntities, formatTextWithCode };
